module.exports = __webpack_public_path__ + "static/media/screen0.b4960438.jpg";